import * as Yup from 'yup';

export const formConstants = {
  stockLot: {
    label: 'Stock Lot',
    name: 'stockLot',
  },
  transferRequests: {
    label: 'Transfer Related Split Requests',
    name: 'transferRequests',
  },
};

export const formValidation = Yup.object().shape({
  stockLot: Yup.string()
    .max(255, 'Stock Lot must be under 255 characters')
    .required('Stock Lot is required'),
  transferRequests: Yup.boolean(),
});
